import React, { Component } from 'react';
import jobs from '../../data/jobs.json';

import { goToTop } from 'react-scrollable-anchor'
import arrow from '../../assets/images/arrowCardRight.svg';
import './jobDetails.scss';

export default class JobDetails extends Component {
  constructor(props){
    super(props);
    goToTop();
    this.job = jobs.filter(job => job.id === this.props.match.params.id)[0];
  }
  render() {
    return (
      <div className="job-details-container">
        <div className="container">
          <div className="row">
            <div className="mx-auto col-md-8">
              <h1 className="text-center job-detail-title">{this.job.title}</h1>
              <div className="text-center">
                {
                  this.job.tags.map((tag, i) => <span className="job-tag" key={i}>{tag}</span>)
                }
              </div>
              <h6 className="heading-job-detail">Working Time and Location</h6>
              <ul>
                <li>{this.job.jobType}</li>
                <li>Location: {this.job['full-location']}</li>
                <li>Salary: {this.job.salary}</li>
              </ul>

              <h6 className="heading-job-detail">Job Description</h6>
              <ul>
                {
                  this.job.jd.map((jd, i) => <li key={i}>{jd}</li>)
                }
              </ul>
              <h6 className="heading-job-detail">Must-have Skills and Experience</h6>
              <ul>
                {
                  this.job.skills.map((s,i) => <li key={i}>{s}</li>)
                }
              </ul>

              <h6 className="heading-job-detail">Nice-have Skills</h6>
              <ul>
                {
                  this.job['nice-to-have-skills'].map((s,i) => <li key={i}>{s}</li>)
                }
              </ul>

              <h6 className="heading-job-detail">Why it would be awesome to work with us</h6>
              <ul>
                {
                  this.job.benefits.map((b,i) => <li key={i}>{b}</li>)
                }
              </ul>

              <h6 className="heading-job-detail">About WIZY</h6>
              <span>Wizy is a global IT solutions provider invested by a Swiss company. With extensive experiences and rich expertise, Wizy specializes in providing IT Solutions, System Integration and Outsourcing Services to worldwide customers.</span>
            </div>
            
          </div>
        </div>

        <div className="row apply-job">
          <div className="col-md-7 mx-auto text-center">
            <h4 className="text-center">Apply This Work</h4>
            <p className="text-center">We are sincerely happy about your desicion. Please send us an email with your CV. We will reply to you when we recieved your information.</p>

            <div className="text-center">
              <button type="button" className="btn btn-primary" onClick={() => {window.location.href = "mailto:hr@wizy.vn?subject=[Apply Job] "}}>
                <span>Apply To This Job</span> <img src={arrow} alt="" />
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/JobDetails/JobDetails.js